/*
 * <collection-filter>
 * FILTER ボタンで全画面フィルターを開閉する。
 * 送信は通常の GET フォーム。値が空のフィールドは URL に載せない。
 */
if (!customElements.get('collection-filter')) {
  customElements.define(
    'collection-filter',
    class CollectionFilter extends HTMLElement {
      connectedCallback() {
        this.overlay = this.querySelector('.cfilter__overlay');
        this.panel = this.querySelector('.cfilter__panel');
        this.form = this.querySelector('.cfilter__form');

        // 開くトリガーはドロワーの外 (コレクションヘッダーの FILTER) にも置けるよう
        // document 全体から拾う
        document.querySelectorAll('[data-cfilter-open]').forEach((el) =>
          el.addEventListener('click', () => this.open())
        );
        this.querySelectorAll('[data-cfilter-close]').forEach((el) =>
          el.addEventListener('click', () => this.close())
        );

        // 空欄の価格フィールドは送信しない (?filter.v.price.gte= が付くのを防ぐ)
        if (this.form) {
          this.form.addEventListener('submit', () => {
            this.form.querySelectorAll('input[type="number"]').forEach((input) => {
              if (input.value === '') input.disabled = true;
            });
          });
        }

        this.onKeydown = (event) => {
          if (event.key === 'Escape') this.close();
        };
      }

      open() {
        if (this.overlay) this.overlay.hidden = false;
        if (this.panel) this.panel.hidden = false;
        document.body.classList.add('cfilter-open');
        // 次のフレームでクラスを付けて、下からせり上がるトランジションを効かせる
        requestAnimationFrame(() => this.classList.add('is-open'));
        document.addEventListener('keydown', this.onKeydown);
      }

      close() {
        this.classList.remove('is-open');
        document.body.classList.remove('cfilter-open');
        document.removeEventListener('keydown', this.onKeydown);
        // トランジションが終わってから hidden に戻す
        setTimeout(() => {
          if (this.classList.contains('is-open')) return;
          if (this.overlay) this.overlay.hidden = true;
          if (this.panel) this.panel.hidden = true;
        }, 300);
      }
    }
  );
}
